<template lang="pug">
#myAgency(v-loading="loading" element-loading-text="数据加载中")
  el-tabs(v-model="activeName" @tab-click="handleClick")
    el-tab-pane(label="我的创建" name="first")
    el-tab-pane(label="我的计划" name="second")
  .content(v-if="activeName==='first'")
    .header-midd
      search(ref="approveSearch"  @change="handleSearch")
    .operations
      el-button(type="primary" size="small" :disabled="multipleSelection.length === 0" @click="batchDownload")  批量下载
    .midd
      el-table(ref="multipleTable"  highlight-current-row size="small" border height="100%"
        :data="tableData" row-key="flowInstanceId"  @selection-change="handleSelectionChange")
        el-table-column(type="selection" width="55" align="center" reserve-selection)
        el-table-column(type="index" label="编号" align="center" width="60")
        el-table-column(label="状态" sortable prop="status" width="80px" align="center" v-slot="{row}")
          span.flowStatus(:class="`type${row.status}`") {{statusName(row.status)}}
        el-table-column(label="流程类型" sortable align="center" prop="flowType" min-width="80px")
        el-table-column(label="标题" sortable prop="title" min-width="120px" v-slot="{row}")
          el-link(type="primary" @click="cellClick(row)")
            span(class="tabLinkSpan" :title='row.title') {{ row.title }}
        el-table-column(label="内容" prop="content" min-width="100px" show-overflow-tooltip)
        el-table-column(label="申请人" prop="flowInstanceOwnerName" align="center" min-width="100px")
        el-table-column(label="开始时间" prop="flowInstanceStartTime" min-width="100px" show-overflow-tooltip)
        el-table-column(label="当前审批人" align="center" prop="currentNodeAssigneeName"  show-overflow-tooltip)
        el-table-column(label="上个审批节点" align="center" prop="lastNodeName"  show-overflow-tooltip)
        el-table-column(label="备注" align="center" prop="remark"  min-width="140px" show-overflow-tooltip)
        el-table-column(label="操作" min-width="110px" align="center" v-slot="{row}")
          el-button(type="text" v-if="row.status === 2" @click.stop="termination(row)") 终止
          el-button(type="text" v-if="row.status !== 9" @click.stop="clickChange(row, 'view')") 查看
          el-button(type="text" v-if="row.status === 9 " @click.stop="clickChange(row,'draft')") 编辑
          el-button(type="text" v-if="row.status === 0 || row.status === 3" @click.stop="clickChange(row,'again')") 重新发起
          el-button(type="text" v-if="row.status === 2" @click.stop="withdraw(row)") 撤回
          el-button(type="text" v-if="row.status === 9" @click.stop="delDraftFlow(row)") 删除
          el-dropdown(v-if="row.status === 1 && row.printTemplateFileId" @command="handleDownClick(row, $event)")
            el-button(type="text") 成果文件
              i(class="el-icon-arrow-down el-icon--right")
            el-dropdown-menu(slot="dropdown")
              el-dropdown-item(command="down") 下载
              el-dropdown-item(command="recreate") 重新生成
    .page
      el-pagination(:current-page.sync="page.pageNum"
        :page-size="page.pageSize"
        :layout="page.pageLayout"
        :total="page.totalCount"
        v-if="page.totalCount > 0"
        :page-sizes="[10, 20, 50, 100]"
        size="small"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange")
  .content(v-if="activeName==='second'")
    .header-midd
      el-form(ref="form" size="small" :model="taskform" inline)
        el-form-item( label="所属项目")
          el-select(v-model="taskform.prjId" size="small" clearable filterable )
            el-option( v-for="item in taskPrjListList" :key="item.prjId" :label="item.prjName" :value="item.prjId")
        el-form-item(label="计划名称")
          el-input(v-model="taskform.taskName" size="small" placeholder="请输入计划名称" clearable filterable)
        el-form-item
          el-button(size="small" type="primary" @click="searchChange") 查 询
          el-button(size="small" type="primary" plain @click="resetForm") 重 置
    .midd
      el-table(ref="multipleTable"  highlight-current-row size="small" border height="100%"
        :data="taskData")
        el-table-column(label="编号" type="index" width="60")
        el-table-column(label="所属项目" prop="prjName")
        el-table-column(label="计划名称" prop="taskName")
        el-table-column(label="计划类型" prop="taskTypeName")
        el-table-column(label="状态" prop="statusName")
        el-table-column(label="责任人" prop="taskUserName" min-width="200px" show-overflow-tooltip)
        el-table-column(label="时间" prop="time")
    .page
      el-pagination(:current-page.sync="page.pageNum"
        :page-size="page.pageSize"
        :layout="page.pageLayout"
        :total="page.totalCount"
        v-if="page.totalCount > 0"
        :page-sizes="[10, 20, 50, 100]"
        size="small"
        background
        @size-change="handleSizeTaskChange"
        @current-change="handleCurrentTaskChange")
</template>

<script>
import search from "@/CommonDP/pages/mainMg/approval/config/search.vue";
import flowService from "@/CommonDP/service/flow-service";
import approvalService from "@/CommonDP/service/approve-service";
import { mapState } from "vuex";
import { getStatusName } from "@/CommonDP/components/processComponents/config";
import { openFlow } from "@/CommonDP/components/processComponents/flowNew/index.js";
import { getDownloadDesignTemplateInfo } from "@/CommonDP/service/listFlow-service";
import { downloadFileShowPrompt, decodeFileName } from "@/CommonDP/utils";
export default {
  name: "MyEstablish",
  components: { search },
  data() {
    return {
      activeName: "first",
      tableData: [],
      multipleSelection: [],
      loading: false,
      page: {
        pageLayout: "total, sizes, prev, pager, next, jumper",
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      },
      taskform: {
        prjId: "",
        taskName: ""
      },
      taskPrjListList: [],
      taskData: [],
      flowRejectDialog: false,
      comment: "", // 审批意见
      flowInstanceNodeId: "",
      approveType: "edit",
      viewMode: 2, // 新增0 审批1 查看2
      statusName: getStatusName
    };
  },
  computed: {
    searchFormParams() {
      return this.$refs.approveSearch.getForm();
    },
    taskformParams() {
      return {
        ...this.taskform,
        enterpriseId: this.enterpriseId,
        taskType: "",
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNum
      };
    },
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  mounted() {
    this.page.pageNum = 1;
    this.getPendList();
  },
  methods: {
    async handleClick(tab, event) {
      this.page.pageNum = 1;
      if (this.activeName === "first") {
        await this.$nextTick();
        this.$refs.approveSearch.resetForm();
        this.getPendList();
      } else {
        this.taskform.prjId = "";
        this.taskform.taskName = "";
        this.getTaskPrjList();
        this.getTaskList();
      }
    },
    handleSearch(form) {
      this.page.pageNum = 1;
      this.getPendList();
    },
    async getPendList() {
      const {
        page: { pageNum, pageSize }
      } = this;
      this.loading = true;
      const { data, pageIndex, totalCount } = await flowService.mySubmit(this.searchFormParams, pageNum, pageSize);
      this.tableData = data;
      this.page.pageNum = pageIndex;
      this.loading = false;
      this.page.totalCount = totalCount;
    },
    updateTable() {
      this.getPendList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getPendList();
    },
    handleCurrentChange(val) {
      this.page.pageNum = val;
      this.getPendList();
    },
    seeBoolean(row) {
      return row.status !== 9;
    },
    // 查看流程
    async clickChange(row, approveType) {
      const { currentVersionId = "", flowInstanceId = "", flowKey, businessId = "", startMode } = row;
      const data = { currentVersionId, flowInstanceId, flowKey, approveType, businessId, enterpriseId: this.enterpriseId, isProject: this.isProject };
      // 新窗口打开
      if (startMode === "stdNew") {
        const routeUrl = this.$router.resolve({ path: "/examine-new", query: data });
        window.open(routeUrl.href, "_blank");
      } else {
        await openFlow(data);
        this.getPendList();
      }
    },
    withdraw(row) {
      this.$confirm(`您确定撤回当前流程吗?`, "警告", { type: "warning" })
        .then(async () => {
          await flowService.withdraw({ flowInstanceId: row.flowInstanceId });
          this.$success("流程撤回成功");
          this.getPendList();
        })
        .catch(() => {
          // this.$message.info("已取消删除");
        });
    },
    async delDraftFlow(row) {
      await this.$confirm("确定删除吗？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      await flowService.delDraftFlow(row.businessType, row.businessId);
      this.getPendList();
    },
    // 流程终止 自己 流程状态是 审批中
    async termination(row) {
      const form = Vue.observable({ remark: "", verify: false });
      const FContent = {
        render() {
          return (
            <div>
              <ElInput vModel={form.remark} size="mini" type="textarea" autosize={{ minRows: 2, maxRows: 6 }} show-word-limit placeholder="请输入终止原因" />
              {form.verify ? <div style="color:#ff0000;">请输入终止原因</div> : undefined}
            </div>
          );
        }
      };
      await this.$msgbox({
        title: "终止流程",
        message: <FContent />,
        showCancelButton: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (!form.remark) form.verify = true;
            else {
              done();
            }
          } else {
            done();
          }
        }
      });
      const params = {
        flowInstanceId: row.flowInstanceId,
        remark: form.remark
      };
      await flowService.terminationFlowInstance(params);
      this.$success("流程终止成功");
      this.getPendList();
    },

    handleSizeTaskChange(val) {
      this.page.pageSize = val;
      this.getTaskList();
    },
    handleCurrentTaskChange(val) {
      this.page.pageNum = val;
      this.getTaskList();
    },
    // 计划项目
    async getTaskPrjList() {
      const res = await approvalService.queryTaskPrjList(this.enterpriseId);
      this.taskPrjListList = res.data;
    },
    async getTaskList() {
      this.loading = true;
      const { data, pageIndex, totalCount } = await approvalService.queryMySubmitListTask(this.taskformParams);
      this.taskData = data;
      this.loading = false;
      this.page.pageNum = pageIndex;
      this.page.totalCount = totalCount;
    },
    // 我的计划查询
    searchChange() {
      this.page.pageNum = 1;
      this.getTaskList();
    },
    // 重置
    resetForm() {
      this.taskform.prjId = "";
      this.taskform.taskName = "";
      this.page.pageNum = 1;
      this.getTaskList();
    },
    cellClick(row) {
      const type = row.status === 9 ? "draft" : "view";
      this.clickChange(row, type);
    },
    handleDownClick(row, command) {
      switch (command) {
        case "down":
          this.downDesignFile(row);
          break;
        case "recreate":
          this.recreateDesignFile(row);
          break;
      }
    },
    async downDesignFile(item) {
      const response = await getDownloadDesignTemplateInfo(item.flowInstanceId);
      const fileName = decodeFileName(response.getHeaders()["content-disposition"]);
      downloadFileShowPrompt(fileName, response);
    },
    async recreateDesignFile(item) {
      await this.$confirm(`确认重新生成成果文件吗？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      this.$success("生成中请稍候，完成后将自动下载成果文件");
      const res = await flowService.recreateDesignFile(item.flowInstanceId);
      item.printTemplateFileId = res.data?.fileId;
      item.printResultFileVersion = res.data?.fileVersion;
      this.downDesignFile(item);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchDownload() {
      const rows = this.multipleSelection.filter((item) => item.status === 1 && item.printTemplateFileId);
      console.log(this.multipleSelection.filter((item) => item.status === 1).length);
      if (rows.length) {
        this.multipleSelection.map((item) => {
          this.downDesignFile(item);
        });
      } else {
        this.$warn("您当前选中的流程尚未完成在线打印设计！请去流程设置中完成打印设计操作！");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#myAgency {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding: 0 var(--big-space);
  display: flex;
  flex-direction: column;
  .el-tabs {
    padding-top: var(--small-space);
  }
  .content {
    height: 1px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
  }
}

.operations {
  position: relative;
  top: -10px;
}

.midd {
  flex: 1 1;
  overflow: hidden;
}

.page {
  margin: var(--middle-space) 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.flowStatus {
  border-radius: 6px;
  text-align: center;
  padding: 2px 8px;
}
.type1,
.type4 {
  border: 1px solid #10a667;
  background: rgba(16, 166, 103, 0.1);
  color: #10a667;
}

.type2 {
  border: 1px solid #ff7a00;
  background: rgba(255, 122, 0, 0.1);
  color: #ff7a00;
}

.type3 {
  border: 1px solid #60656b;
  background: rgba(96, 101, 107, 0.1);
  color: #60656b;
}

.type8 {
  border: 1px solid #9746e8;
  background: rgba(151, 70, 232, 0.1);
  color: #9746e8;
}

.type9 {
  border: 1px solid #2f8bf8;
  background: rgba(47, 139, 248, 0.1);
  color: #2f8bf8;
}

.type0 {
  border: 1px solid #ff4a4a;
  background: rgba(255, 74, 74, 0.1);
  color: #ff4a4a;
}
</style>
